import { createContext, useContext } from "react";

export type ToastTone = "success" | "danger" | "warning" | "info";
export type ToastInput = {
  title: string;
  description?: string;
  tone?: ToastTone;
  replaceKey?: string;
};

export const ToastContext = createContext<((toast: ToastInput) => void) | null>(null);

const ignoreToast = (_toast: ToastInput) => undefined;

export function useToast() {
  const notify = useContext(ToastContext);
  if (!notify) throw new Error("useToast must be used within ToastProvider");
  return notify;
}

export function useOptionalToast() {
  return useContext(ToastContext) ?? ignoreToast;
}
